import { useState, useCallback } from 'react';
import { run } from '@zootools/email-spell-checker';

export interface MailSuggestion {
  address: string;
  domain: string;
  full: string;
}

export interface UseEmailSpellCheckReturn {
  suggestion: MailSuggestion | null;
  checkEmail: (email: string) => void;
  applySuggestion: () => string | null;
  clearSuggestion: () => void;
}

export const useEmailSpellCheck = (initialEmail?: string): UseEmailSpellCheckReturn => {
  const [suggestion, setSuggestion] = useState<MailSuggestion | null>(null);
  const [currentEmail, setCurrentEmail] = useState(initialEmail || '');

  const checkEmail = useCallback((email: string) => {
    setCurrentEmail(email);
    if (!email || !email.includes('@')) {
      setSuggestion(null);
      return;
    }

    const result = run({ email });
    if (result && result.full !== email) {
      setSuggestion(result);
    } else {
      setSuggestion(null);
    }
  }, []);

  const applySuggestion = useCallback(() => {
    if (suggestion) {
      const newEmail = suggestion.full;
      setSuggestion(null);
      return newEmail;
    }
    return null;
  }, [suggestion]);

  const clearSuggestion = useCallback(() => {
    setSuggestion(null);
  }, []);

  return {
    suggestion,
    checkEmail,
    applySuggestion,
    clearSuggestion,
  };
};
